import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (c) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          stroke: "currentcolor",
          strokeWidth: 2,
          d: "M14.25 18.102h2.745c2.583 0 3.914-1.896 4.026-3.71a55.5 55.5 0 0 0-.026-7.289c-.187-2.612-1.913-3.766-3.887-3.825a74 74 0 0 0-5.117-.175c-1.689 0-3.83.089-5.432.204S3.11 4.577 2.995 7.103a53.5 53.5 0 0 0-.029 7.097c.144 2.304 1.749 3.902 4.087 3.902h3.345v2.49z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M10.014 7.536c-.258-1-1.679-1-1.937 0L7.8 8.616a1 1 0 0 1-.719.718l-1.079.278c-1 .258-1 1.679 0 1.937l1.08.278a1 1 0 0 1 .718.719l.278 1.079c.258 1 1.679 1 1.937 0l.278-1.08a1 1 0 0 1 .719-.718 3.96 3.96 0 0 1 1.979 0 1 1 0 0 1 .718.719l.278 1.079c.258 1 1.68 1 1.937 0l.278-1.08a1 1 0 0 1 .719-.718l1.079-.278c1-.258 1-1.679 0-1.937l-1.079-.278a1 1 0 0 1-.719-.719l-.278-1.079c-.258-1-1.678-1-1.937 0l-.278 1.08a1 1 0 0 1-.718.718 3.96 3.96 0 0 1-1.98 0 1 1 0 0 1-.718-.719z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  t as default
};
